<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="tskInfoCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="autoTableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="
        disabled
          ? {}
          : {
              highlight: true,
              reserve: true,
              checkMethod: ({ row }) => row.tskStatus === 'A',
            }
      "
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:taskTime="{ row }">
        <div>
          {{ row.tskInfoNo }}
        </div>
        <div class="mt-2 d-flex">
          <div class="icon-task-type mr-2">
            <img :src="row.iconUrl" />
          </div>
          <div class="level-tag">
            <el-tag size="mini" effect="dark" :type="row.tskImportantLevel">
              {{ row.v_tskImportantLevel }}
            </el-tag>
          </div>
        </div>
      </template>
      <template v-slot:taskTitle="{ row }">
        <div>
          <div class="mb-1">
            <div class="task-cust-icon inline-block mr-2">
              <img :src="vipIcon" />
            </div>
            <div class="inline-block">{{ row.custName }}</div>
          </div>
          {{ row.tskOverview }}
        </div>
      </template>
      <template v-slot:taskStatus="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.tskStatus == 'N' || row.tskStatus == 'A' 
                ? 'info'
                : row.tskStatus == 'P'
                ? ''
                : row.tskStatus == 'U'
                ? 'warning'
                : row.tskStatus == 'C'
                ? 'success'
                : row.tskStatus == 'Y'
                ? 'success'
                : 'danger'
            "
          >
            {{ row.v_tskStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:tskEndDate="{ row }">
        <div>
          {{ row.tskEndDate }}
        </div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          effect="dark"
          :content="'任务下发'"
          placement="right"
          v-if="row.tskStatus === 'A'"
        >
          <i class="el-icon-check tool-btn" @click="dispatchTask(row)" />
        </el-tooltip>
      </template>
    </vxe-grid>

    <choose-sample-dialog
      :visible.sync="chooseSampleVisible"
      type="radio"
      @confirm="sampleConfirm"
      :confirm-on-close="false"
    />
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
const vipIcon = require('../../icon/vip.png')
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    autoHeight: { type: Boolean, default: false },
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      chooseSampleVisible: false,
      selectionCode: '',
      vipIcon,
      format: (n) => format(n),
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
    autoTableHeight() {
      if (!this.autoHeight) {
        return this.height < 560 ? 560 : this.height
      } else {
        return this.tableHeight < 300 ? 300 : this.tableHeight - 30
      }
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'binding':
          this.chooseSampleVisible = true
          this.selectionCode = data.selectionCode
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async sampleConfirm(data) {
      if (!data) return
      const confirm = await this.$confirm(
        this.$l('tips_bind_sample') || '是否绑定选中的样品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const params = {
        sampleCode: data.sampleCode,
        selectionCode: this.selectionCode,
      }

      this.loadingOpen()
      const res = await this.$api
        .expoMeetingSelectionBindSamplesApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.chooseSampleVisible = false
      this.selectionCode = false
      this.$emit('reload')
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { tskStatus } = row
      if (tskStatus !== 'A') return

      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    async dispatchTask(row) {
      const { tskInfoCode } = row
      const confirm = await this.$confirm(
        this.$l('tips_confirm_dispatchTask') || '是否确认下发任务？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX._btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoMeetingDispatchApi({ listTskInfoCode: [tskInfoCode] })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_dispatchTask_no') || '下发失败！')
        return
      }
      this.$message({
        message: this.$l('tips_dispatchTask_ok') || '下发成功！',
        type: 'success',
      })
      this.$emit('reload')

      const $table = this.$refs.table
      $table.setCheckboxRow(row, false)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
}
.inline-block {
  display: inline-block;
}
.task-cust-icon {
  width: 18px;
  height: 18px;
  > img {
    width: 18px;
    height: 18px;
  }
}
.icon-task-type {
  width: 20px;
  height: 18px;
  > img {
    width: 20px;
    height: 18px;
  }
}
</style>
